import styled, { css } from 'styled-components';

/**
 * StatusBadge component for displaying status information
 * Usage:
 * <StatusBadge status="open">Open</StatusBadge>
 * <StatusBadge status="pending">Pending</StatusBadge>
 * <StatusBadge status="accepted">Accepted</StatusBadge>
 * <StatusBadge status="rejected">Rejected</StatusBadge>
 * <StatusBadge status="interview">Interview</StatusBadge>
 */
const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  ${props => {
    // Convert status to lowercase for case-insensitive comparison
    const status = props.status ? props.status.toLowerCase() : '';
    
    switch(status) {
      case 'open':
        return css`
          background-color: rgba(15, 157, 88, 0.1);
          color: #0F9D58;
          border: 1px solid rgba(15, 157, 88, 0.2);
        `;
      case 'closing-soon':
        return css`
          background-color: rgba(244, 180, 0, 0.1);
          color: #F4B400;
          border: 1px solid rgba(244, 180, 0, 0.2);
        `;
      case 'closed':
        return css`
          background-color: rgba(219, 68, 55, 0.1);
          color: #DB4437;
          border: 1px solid rgba(219, 68, 55, 0.2);
        `;
      case 'pending':
        return css`
          background-color: rgba(244, 180, 0, 0.1); /* Updated to match image: amber color */
          color: #F4B400;
          border: 1px solid rgba(244, 180, 0, 0.2);
        `;
      case 'finalized':
        return css`
          background-color: rgba(103, 58, 183, 0.1);
          color: #673AB7;
          border: 1px solid rgba(103, 58, 183, 0.2);
        `;
      case 'interview':
        return css`
          background-color: rgba(66, 133, 244, 0.1); /* Updated to match image: blue color */
          color: #4285F4;
          border: 1px solid rgba(66, 133, 244, 0.2);
        `;
      case 'accepted':
        return css`
          background-color: rgba(15, 157, 88, 0.1);
          color: #0F9D58;
          border: 1px solid rgba(15, 157, 88, 0.2);
        `;
      case 'rejected':
        return css`
          background-color: rgba(219, 68, 55, 0.1);
          color: #DB4437;
          border: 1px solid rgba(219, 68, 55, 0.2);
        `;
      case 'flagged':
        return css`
          background-color: rgba(244, 180, 0, 0.1);
          color: #F4B400;
          border: 1px solid rgba(244, 180, 0, 0.2);
        `;
      default:
        return css`
          background-color: rgba(95, 99, 104, 0.1);
          color: #5F6368;
          border: 1px solid rgba(95, 99, 104, 0.2);
        `;
    }
  }}
  
  ${props => props.size === 'small' && css`
    padding: 0.2rem 0.5rem;
    font-size: 0.65rem;
  `}
  
  ${props => props.size === 'large' && css`
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  `}
`;

export default StatusBadge;
